<template>
	<div style="overflow:auto;height: 600px;">
		<div class="list_box" v-for="(item, index) in count" :key="index" infinite-scroll-disabled="disabled">
			<div class="two-overflow type_size_22">{{ item.title_pure }}</div>
			<div class="p_flex p_f_a p_f_b p_m_t_20">
				<div class="p_flex type_size_16">
					<span class="subject_color">{{ item.grade_def }}</span>
					<el-divider direction="vertical"></el-divider>
					<span class="subject_yellow">{{ item.subject_def }}</span>
					<el-divider direction="vertical"></el-divider>
					<span>
						{{
							item.question_type == 1
								? '单选题'
								: item.question_type == 2
								? '多选题'
								: item.question_type == 3
								? '判断题'
								: item.question_type == 4
								? '填空题'
								: item.question_type == 5
								? '问答题'
								: '材料题'
						}}
					</span>
					<el-divider direction="vertical"></el-divider>
					<span>{{ item.score }}分</span>
				</div>
				<div class="p_flex">
					<el-button type="info" plain size="mini" @click="sc(item.id)">删除</el-button>
				<!-- 	<el-button type="info" plain size="mini">修改</el-button> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		grades: Number,
		breadcrumb: Number
	},
	data() {
		return {
			count: [],
			loading: false,
			grade: 0,
			subject: 0,
			name: '',
			namesd: '',
			namesdd: '',
			namesddd: '',
			jkh: '',
			hjs: '',
			ids: []
		};
	},
	watch: {
		grades: {
			handler(i, o) {
				// console.log(i)
				var is = i == '' ? this.jkh : i;
				// console.log(is)
				if (this.jkh != is) {
					this.count = [];
				}
			}
		},
		breadcrumb: {
			handler(i) {
				// console.log(i)
				var is = i == '' ? this.hjs : i;
				// console.log(is)
				if (this.hjs != is) {
					this.count = [];
				}
			}
		},
		count: {
			handler(i, o) {
				// console.log(i)
				this.$emit('np', i);
				if (i.length <= 0 && this.$route.query.id) {
					this.$router.push('/Exercise');
					this.$router.go(0);
				}
			}
		}
	},
	created() {
		// console.log(this.$route.query.hjs)
		// console.log(this.$route.query.jkh)
		// console.log(this.$route.query.js)
		if (this.$route.query.js) {
			var ojbk = this.$route.query.js.split('|'); //分割完返回过来后是一个数组
			// console.log(ojbk)
			this.$request
				.ajax(this)
				.post('/api_teacher/question_list', {
					ids: ojbk
				})
				.then(res => {
					console.log(res)
					for( var i = 0; i<res.data.list.length; i++){
						this.ids.push(res.data.list[i].id)
						this.$emit('delete', this.ids);
					}
				this.count = res.data.list;
				});
		}
		this.jkh = this.$route.query.jkh;
		this.hjs = this.$route.query.hjs;
		if (this.$route.query.id) {
			this.ids = this.$route.query.id;
			if (this.ids.length != 0) {
				this.get();
			}
		}
	},
	mounted() {},
	methods: {
		get() {
			if (this.ids.length != 0) {
				this.$request
					.ajax(this)
					.post('/api_teacher/question_list', {
						ids: this.ids //已选择的习题id
					})
					.then(res => {
						// console.log(res);
						this.count = res.data.list;
					});
			}else{
				this.count = []
			}
		},
		sc(id) {
			for (var i = 0; i < this.ids.length; i++) {
				if (id == this.ids[i]) {
					this.ids.splice(i, 1);
					// console.log(this.ids)
					this.$emit('delete', this.ids);
						this.get();
				}
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.list_box {
	padding: 20px 0;
	border-bottom: 1px solid #e6e6e6;
	margin: 0 20px;
}
>>> .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
	border-color: #00af63;
	background: #00af63;
}
>>> .el-checkbox__input.is-checked + .el-checkbox__label {
	color: #00af63;
}
>>> .el-checkbox__inner {
	width: 18px;
	height: 18px;
}
>>> .el-checkbox__label {
	font-size: 18px;
}
>>> .el-checkbox__inner:hover {
	border-color: #999999;
}

>>> .el-checkbox__inner::after {
	height: 9px;
	left: 6px;
	top: 1px;
	width: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/commponents/exerciseTopic.vue